import React from "react";
import "../styles/globalStyles.css";

export const CounterWidget = props => {
    return (
        <div
            className="aua-badge"
            style={{color: "#7c878e"}}
            
        >
            {props.count} {props.count != 1 ? "questions" : "question"}
        </div>
    );
};
